import { Link, useNavigate } from "@tanstack/react-router";

import LogoWL from "~/assets/check.svg";
import { Button } from "@workspace/web-ui/components/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@workspace/web-ui/components/dialog";
import { useSuccessModal } from "~/features/onboarding/store/use-success-modal";

// import { useAuthModal } from "../pages/welcome/store/use-auth-modal";
// import { useRegisterModal } from "../pages/welcome/store/use-register-modal";

export function SuccessModal() {
  const { isOpen, close } = useSuccessModal();
  const navigate = useNavigate()
//   const { open: openAuthModal } = useAuthModal();
//   const { open: openRegisterModal } = useRegisterModal();

//   function handleLogin() {
//     close();
//     openAuthModal();
//   }

  function handleDashboard() {
    close();
    // window.location.href = "/dashboard";
    navigate({to: "/dashboard"})
  }

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent className="max-w-xs rounded-[24px] px-4 pb-8 pt-6 sm:max-w-sm sm:px-8 sm:pb-10 sm:pt-8 md:max-w-xl lg:px-[64px] lg:pb-[60px] lg:pt-[40px] xl:max-w-[700px]">
        <div
          className="flex shrink-0 items-center justify-center"
          aria-hidden="true"
        >
          <Link to="/" className="mx-auto mb-4 sm:mb-6 lg:mb-[24px]">
            <img src={LogoWL} alt="Proxymed logo" className="w-32 sm:w-auto" />
          </Link>
        </div>
        <div className="flex flex-col items-center gap-2 xl:mb-[48px]">
          <DialogHeader>
            <DialogTitle className="text-center text-2xl font-bold sm:text-3xl lg:text-[40px] xl:mb-[16px]">
              Success
            </DialogTitle>
            <DialogDescription className="text-center text-base leading-[27px] sm:text-lg">
            Your weight loss questionnaire has been successfully submitted.
            </DialogDescription>
          </DialogHeader>
        </div>

        <div className="mb-[24px]">
          <Button
            type="button"
            className="h-12 sm:h-[50px] lg:h-[57px]"
            fullWidth
            size="xl"
            onClick={handleDashboard}
          >
            Back to dashboard
          </Button>
        </div>

      </DialogContent>
    </Dialog>
  );
}
